import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-admin';
import { useParams } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import moment from 'moment';
import { useMediaQuery } from '@material-ui/core';
import SplitView from './SplitView';
import { DispatchProvider } from '../Context';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: '20px',
    margin: '10px 0',
  },
  dispatchHeader: {
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      alignItems: 'flex-start',
      flexDirection: 'column',
    },
  },
}));

const Dispatch = () => {
  const { date } = useParams();
  const classes = useStyles();
  const [dispatchDate, setDispatchDate] = useState(
    date || moment().format('YYYY-MM-DD'),
  );
  const [mapData, setMapData] = useState(null);
  const [reOrdered, setReOrdered] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    if (date) {
      setDispatchDate(date);
    }
  }, [date]);

  const handleDate = (val) => {
    const formatDate = moment(val).format('YYYY-MM-DD');
    setMapData(null);
    setDispatchDate(formatDate);
  };

  const { loading, data: schedule } = useQuery({
    type: 'getList',
    resource: 'schedule',
    payload: {
      pagination: { page: 1, perPage: 1000 },
      sort: { field: 'date', order: 'ASC' },
      filter: { start_time_after: dispatchDate, end_time_before: dispatchDate },
    },
  });

  if (loading && mapData) {
    setMapData(null);
  }
  const values = {
    schedule,
    mapData,
    setMapData,
    dispatchDate,
    setDispatchDate,
    handleDate,
    loading,
    reOrdered,
    setReOrdered,
    isEditing,
    setIsEditing,
  };
  const isSmall = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  return (
    <DispatchProvider value={values}>
      <div className={classes.root}>
        <Grid container>
          <Grid item xs={12}>
            <Paper className={`${classes.paper}`}>
              <Box className={classes.dispatchHeader}>
                <Box width={isSmall ? '100%' : 'auto'}>
                  <SplitView loading={loading} />
                </Box>
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </div>
    </DispatchProvider>
  );
};

export default Dispatch;
